export default __webpack_public_path__ + "static/media/account.7f73584e.svg";